import { Injectable } from '@angular/core';
import { HttpClient,  HttpHeaders  } from '@angular/common/http';

import { User } from '../_models';
import { config } from 'process';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })

export class UserService {
  public currentUser :any;
    constructor(private http: HttpClient) { }

    getUserByEmailID(emailId: string,provider: string) {
        let getUserByEmailIDUrl= `${environment.apiUrl + environment.GetUserByEmailID}?emailID=${emailId}&provider=${provider}`;
        return this.http.get<any>(getUserByEmailIDUrl);
      }

      UpdateUserInfo(userInfo){
        const _name = 'Authorization';
    let Authorization1 = "";
    let Authorization = `; ${document.cookie}`.match(`;\\s*${_name}=([^;]+)`);
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${_name}=`);
  if (parts.length === 2) { Authorization1 =  parts.pop().split(';').shift();}
  this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  if(Authorization1 == null || Authorization1 == ""){
    Authorization1 = localStorage.getItem('Authorization');
  }
    const HttpUploadOptions = {
      headers: new HttpHeaders(
        {
          "Authorization": Authorization1,
          "EmailId":this.currentUser.EmailID
        })
    }
        return this.http.post(`${environment.apiUrl + environment.UpdateUserInfo}`, userInfo,HttpUploadOptions);
      }

      getUserByID(userID: number) {
        let getUserByIDUrl= `${environment.apiUrl + environment.GetUserByID}?userID=${userID}`;
        return this.http.get<any>(getUserByIDUrl);
      }
      

}